<!--
 * @Author       : 四川华西绿舍建材有限公司
 * @Date         : 2023-06-27 14:20:42
 * @LastEditTime : 2023-06-27 18:04:25
 * @LastEditors  : yangxr
 * @Description  : 报告弹窗选择组件
 * @FilePath     : \icps_fb\src\views\platform\ICPS\smart\components_data\reportDig.vue
-->
<template>
  <!-- 报告选择 -->
  <el-dialog v-dialogDrag :visible.sync="reportDig" width="1080px" @close="close">
    <span slot="title" class="dialog-title">{{ reportText }}</span>
    <div class="dialogOtherinfo">
      <div class="search">
        <span style="display: inline-block; margin-bottom: 10px">
          <span style="margin-right: 12px">原物料</span>
          <el-select v-model="reportParam.rawId" placeholder="请选择" style="width: 150px" filterable clearable>
            <el-option v-for="(item, index) in rawDicArry" :key="index" :label="item.itemName" :value="item.id"></el-option>
          </el-select>
        </span>
        <span v-if="reportType != 3" style="margin-left: 24px">
          <span style="margin-right: 12px">规格</span>
          <el-select v-model="reportParam.specificationId" placeholder="请选择" style="width: 150px" filterable clearable>
            <el-option v-for="(item, index) in specificationArry" :key="index" :label="item.itemName" :value="item.id"></el-option>
          </el-select>
        </span>
        <span v-if="reportType != 3" style="margin-left: 24px">
          <span style="margin-right: 12px">品牌</span>
          <el-select v-model="reportParam.brandId" placeholder="请选择" style="width: 150px" filterable clearable>
            <el-option v-for="(item, index) in brandArry" :key="index" :label="item.itemName" :value="item.id"></el-option>
          </el-select>
        </span>
        <span v-if="reportType == 3" style="margin-left: 24px">
          <span style="margin-right: 12px">供应商</span>
          <el-input v-model="reportParam.supplierName" placeholder="请输入" style="width: 250px" clearable></el-input>
        </span>
        <el-button icon="el-icon-search" size="medium" class="bottom_all" @click="(reportParam.page = 1), getReport()">查 询</el-button>
      </div>
      <el-table :header-cell-style="{ background: '#f3f6f9' }" :cell-style="{ borderRight: 'none' }" border stripe style="width: 100%" :data="reportTableData" tooltip-effect="dark" @row-click="ListChoiceFun">
        <el-table-column width="55">
          <template slot-scope="scope">
            <el-radio v-model="selectReportId" :label="scope.row.id">{{ "" }}</el-radio>
          </template>
        </el-table-column>
        <template v-for="(item, index2) in reportType == 3 ? reportTable_2 : reportType == 4 ? reportTable_3 : reportTable_1">
          <el-table-column v-if="item.status" :key="index2" :label="item.label" align="center" :width="item.width">
            <template slot-scope="scope">
              <span>{{ scope.row[item.prop] }}</span>
            </template>
          </el-table-column>
        </template>
      </el-table>
      <div class="card_bottom">
        <div class="card_bottom_left">
          <div class="top_page_totle">总共{{ reportParam.total }}条</div>
          <el-pagination
            :current-page.sync="reportParam.page"
            :page-size="reportParam.pageSize"
            :page-sizes="[10, 20, 30, 40, 50, 100, 200, 500, 1000]"
            layout="prev,pager,sizes,next,jumper"
            :total="reportParam.total"
            @size-change="reportSizeChange"
            @current-change="getReport()"
          ></el-pagination>
        </div>
      </div>
    </div>
    <span slot="footer" class="dialog-footer">
      <el-button class="bottom_all_two" @click="close">取 消</el-button>
      <el-button class="bottom_all" style="margin-left: 24px" @click="confirmReport()">确 定</el-button>
    </span>
  </el-dialog>
</template>

<script>
import { getReportService, getThirdReport, getThirdReport2 } from "@/api/smart/data.js";
import { getDicType } from "@/api/common.js";
export default {
  props: {
    reportDig: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {
      //导出开盘资料选择报告
      reportTableData: [],
      reportTable_1: [
        { label: "报告编号", prop: "reportCode", status: true, width: "auto" },
        { label: "原物料名称", prop: "rawName", status: true, width: "auto" },
        { label: "规格", prop: "specification", status: true, width: "220" },
        { label: "品牌", prop: "brandName", status: true, width: "auto" },
        { label: "年月", prop: "yearMonthTime", status: true, width: "200" },
        { label: "检测报告", prop: "checkReport", status: true, width: "150" },
      ],
      reportTable_2: [
        { label: "报告编号", width: "auto", prop: "reportNo", status: true },
        { label: "供应商", width: "120", prop: "supplierName", status: true },
        { label: "原物料名称", width: "120", prop: "rawName", status: true },
        {
          label: "检验时间",
          width: "160",
          prop: "inspectionTime",
          status: true,
        },
        {
          label: "检验结果",
          width: "auto",
          prop: "inspectionResult",
          status: true,
        },
      ],
      reportTable_3: [
        { label: "报告编号", width: "auto", prop: "reportNo", status: true },
        { label: "工程名称", width: "120", prop: "engineeringName", status: true },
        { label: "产品名称", width: "120", prop: "productName", status: true },
        {
          label: "检验时间",
          width: "160",
          prop: "inspectionTime",
          status: true,
        },
        {
          label: "检验结果",
          width: "auto",
          prop: "inspectionResult",
          status: true,
        },
      ],
      reportParam: {
        page: 1,
        pageSize: 10,
      },

      reportType: 1,
      reportText: "",
      specificationArry: [],
      rawDicArry: [], //字典数据
      brandArry: [],
      selectReport: {},
      selectReportId: "",
    };
  },
  mounted() {
    getDicType({ code: "MATspec" }).then(res => {
      this.specificationArry = res.data.items; //
    });
    getDicType({ code: "MATname" }).then(res => {
      this.rawDicArry = res.data.items;
    });
    getDicType({ code: "MATbrand" }).then(res => {
      this.brandArry = res.data.items;
    });
  },
  methods: {
    confirmReport() {
      this.$emit("confirmReport", this.selectReportId, this.selectReport);
    },
    close() {
      this.$emit("colseReprotDig");
    },
    //单选选中
    ListChoiceFun(currentRow) {
      if (currentRow) {
        this.selectReport = currentRow;
        this.selectReportId = currentRow.id;
      }
    },
    reportSizeChange(value) {
      this.reportParam.pageSize = value;
      this.getReport();
    },
    getReport() {
      if (this.reportType == 1 || this.reportType == 2) {
        this.reportParam.type = this.reportType == 1 ? 1 : 2;
        getReportService(this.reportParam).then(res => {
          if (res.code == 1001) {
            this.reportTableData = res.data.data;
            this.reportParam.total = res.data.totalRows;
          }
        });
      } else if (this.reportType == 4) {
        getThirdReport2(this.reportParam).then(res => {
          if (res.code == 1001) {
            this.reportTableData = res.data.data;
            this.reportParam.total = res.data.totalRows;
          }
        });
      } else {
        getThirdReport(this.reportParam).then(res => {
          if (res.code == 1001) {
            this.reportTableData = res.data.data;
            this.reportParam.total = res.data.totalRows;
          }
        });
      }
    },
    //type 1厂家材质报告、合格证 2第三方报告
    choiceReport(index, type, text) {
      this.reportText = text;
      this.reportIndex = index;
      this.reportType = type;
      this.getReport();
      this.selectReport = "";
      this.selectReportId = "";
    },
  },
};
</script>

<style>
</style>